import { DocumentationPageContentItem, PageBlockDefinition, PageBlockDefinitionProperty } from "../documentation";
import { PageBlockItemUntypedValue, PageBlockItemV2 } from "./data";
import { PageBlockEditorModelV2 } from "./page-block-v2";

//
// Traverse
//

/**
 * Pay attention to correct types!
 */
export function mapPageBlockItemValuesV2(
  pageItems: DocumentationPageContentItem[],
  definitionsMap: PageBlockDefinitionsMap,
  fn: (
    block: PageBlockEditorModelV2,
    item: PageBlockItemV2,
    property: PageBlockDefinitionProperty,
    value: PageBlockItemUntypedValue
  ) => PageBlockItemUntypedValue
) {
  traversePageBlockItemsV2(pageItems, (block, item) => {
    Object.entries(item.props).forEach(([propKey, value]) => {
      const property = definitionsMap.getDefinitionProperty(block.data.packageId, propKey);
      if (!property) return;

      item.props[propKey] = fn(block, item, property, value);
    });
  });
}

export function traversePageBlockItemValuesV2(
  pageItems: DocumentationPageContentItem[],
  definitionsMap: PageBlockDefinitionsMap,
  fn: (
    block: PageBlockEditorModelV2,
    item: PageBlockItemV2,
    property: PageBlockDefinitionProperty,
    value: PageBlockItemUntypedValue
  ) => void
) {
  traversePageBlockItemsV2(pageItems, (block, item) => {
    Object.entries(item.props).forEach(([propKey, value]) => {
      const property = definitionsMap.getDefinitionProperty(block.data.packageId, propKey);
      if (!property) return;

      fn(block, item, property, value);
    });
  });
}

export function traversePageBlockItemsV2(
  pageItems: DocumentationPageContentItem[],
  fn: (block: PageBlockEditorModelV2, item: PageBlockItemV2) => void
) {
  traversePageItemsV2(pageItems, block => {
    block.data.items.forEach(item => {
      fn(block, item);
    });
  });
}

export function traversePageItemsV2(
  pageItems: DocumentationPageContentItem[],
  fn: (item: PageBlockEditorModelV2) => void
): void {
  for (const item of pageItems) {
    switch (item.type) {
      case "Block":
        fn(item);

        break;

      case "Section":
        item.items.forEach(i => {
          i.columns.forEach(c => {
            traversePageItemsV2(c.blocks, fn);
          });
        });

        break;
    }
  }
}

//
// Definitions map
//

export class PageBlockDefinitionsMap {
  private definitionsMap = new Map<string, PageBlockDefinition>();
  private propertiesMap = new Map<string, PageBlockDefinitionProperty>();

  constructor(definitions: PageBlockDefinition[]) {
    definitions.forEach(d => {
      this.definitionsMap.set(d.id, d);
      d.item.properties.forEach(p => {
        this.propertiesMap.set(this.propertyKey(d.id, p.id), p);
      });
    });
  }

  getDefinition(id: string): PageBlockDefinition | undefined {
    return this.definitionsMap.get(id);
  }

  getDefinitionProperty(defId: string, propId: string): PageBlockDefinitionProperty | undefined {
    return this.propertiesMap.get(this.propertyKey(defId, propId));
  }

  private propertyKey(defId: string, propId: string): string {
    return `${defId}.${propId}`;
  }
}
